export const useHttp = () => {
  const config = useRuntimeConfig()
  const locale = useCookieLocale()
  const csrf = useCookie('csrftoken')
  const rc = useRequestHeaders(['cookie'])

  const defaultOpts = {
    credentials: 'include',
    mode: 'cors',
    method: 'POST',
    headers: {},
  }

  return async function http(url, opts = {}, busyState = null) {
    const endpoint = `${config.public.apiUrl}/${url.replace(/^\/+/g, '')}`

    const merged = { ...defaultOpts, ...opts }
    merged.headers = { ...merged.headers }

    // Language header
    merged.headers['Accept-Language'] = locale.value

    // CSRF handling
    if (['POST', 'PATCH', 'DELETE'].includes(merged.method.toUpperCase())) {

      if (csrf.value) {
        merged.headers['X-CSRFToken'] = csrf.value
      }

      if (!merged.files) {
        merged.headers['Content-Type'] = 'application/json'
      } else {
        delete merged.headers['Content-Type']
      }

      if (merged.method.toUpperCase() === 'DELETE') {
        delete merged.headers['Content-Type']
      }
    }

    // Forward cookies during SSR
    merged.headers = { ...merged.headers, ...rc }

    if (busyState) busyState.value = true

    try {
      const data = await $fetch(endpoint, merged)
      const base = ['success', 'results', 'message']
      const meta = Object.keys(data)
        .filter(key => !base.includes(key))
        .reduce((obj, key) => {
          obj[key] = data[key]
          return obj
        }, {})

      return {
        data: data?.results,
        error: null,
        success: data.success,
        meta,
      }
    } catch (error) {
      return {
        data: error?.data ?? null,
        error: error?.message ?? 'Request failed',
        success: false,
        meta: {},
      }
    } finally {
      if (busyState) busyState.value = false
    }
  }
}
